import { Button, Modal, Text } from '@driftt/dds'
import React from 'react'

interface LeavingModal {
  open: boolean
  handleExit: () => void
  handleContinue: () => void
  handleSave: () => void
}

const LeavingModal = ({
  open,
  handleExit,
  handleContinue,
  handleSave,
}: LeavingModal) => {
  return (
    <Modal.Root open={open} onClose={handleContinue}>
      <Modal.Dialog size="medium" variant="warning">
        <Modal.Title title="You have unsaved changes" />

        <Modal.Content scrollOverflow="inside">
          <Text>
            Are you sure you want to exit this page without saving your changes?
          </Text>
        </Modal.Content>

        <Modal.Actions>
          <Button variant="tertiary" onClick={handleExit}>
            Exit without saving
          </Button>
          <Button variant="secondary" onClick={handleContinue}>
            Continue editing
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default LeavingModal
